import { Injectable } from '@angular/core';
import { UserRole } from './roles.enum';
import { AppFeature } from './features.enum';
import { RoleAccessMap } from './role-access.map';
 
@Injectable({ providedIn: 'root' })
export class RoleAccessService {
    hasAccess(userRoles: UserRole[], feature: AppFeature): boolean {
        if (!Array.isArray(userRoles)) return false;
        // Defensive: ensure userRoles is always an array before using map/some
        return Array.isArray(userRoles) && userRoles.some((role) => RoleAccessMap[feature]?.includes(role));
    }
isReadOnly(userRoles: (UserRole | string)[]): boolean {
  console.log('Checking read-only for roles:', userRoles);
 
  let rolesArray: (UserRole | string)[] = [];
 
  if (Array.isArray(userRoles)) {
    // already a proper array
    rolesArray = userRoles;
  } else if (typeof userRoles === 'string') {
    try {
      const parsed = JSON.parse(userRoles);
      rolesArray = Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      rolesArray = [userRoles];
    }
  }
 
  console.log('Normalized roles array:', rolesArray);
 
  const isReadOnly = rolesArray.some(
    role => role === UserRole.ReadOnly || role === 'read_only_group'
  );
 
  console.log('Final isReadOnly result:', isReadOnly);
  return isReadOnly;
}
 
 
}